const mutations = {
  'SET_STORES' (state, value) {
    state.stores = value
  },
  'SET_STORE' (state, value) {
    state.store = value
  },
  'SET_STATUS_STORES' (state, value) {
    state.statusStores = value
  },
  'UPDATE_STORE' (state, value) {
    const index = state.stores.findIndex(store => store.id === value.id)
    if (index !== -1) {
      state.stores.splice(index, 1, { ...value })
    }
  }
}
export default mutations
